import { render, staticRenderFns } from "./YourTemplates.vue?vue&type=template&id=c60bdb2e&"
import script from "./YourTemplates.vue?vue&type=script&lang=ts&"
export * from "./YourTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports